// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__Hcn4Z","main":"Layout_main__i-zHU","loading":"Layout_loading__plgbS"};